import ApplicationSerializer from 'lumen/serializers/application';

export default class CentralMappingOrganizationSettingsSerializer extends ApplicationSerializer {
  modelNameFromPayloadKey(key: string): string {
    if (key === 'organization_settings') {
      return 'central-mapping/organization-settings';
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  payloadKeyFromModelName(): string {
    return 'organization_settings';
  }
}
